import './polyfills'
import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import introscroll from './components/introscroll'
import spesialmodul from './components/media/spesialmodul'
import stegvisVideo from '@nrk/dh-basis-stegvis-video'
import levendeStillbilde from '@nrk/dh-basis-levende-stillbilde'
import { toArray } from '@nrk/dh-basis-common'

import styles from './components/introscroll.module.css'
import './components/cards/alt-text.module.css'
import './client.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends BaseElement {
  name = tag

  render() {
    if (this.features.sanityPreview) {
      // TODO: Load sanity preview script
    }
    this.initCustomElements()
  }

  async initCustomElements() {
    safeDefine('dh-introscroll', introscroll)
    safeDefine('dh-ints-basis-stegvis-video', stegvisVideo)
    safeDefine('dh-ints-basis-levende-stillbilde', levendeStillbilde)
    safeDefine('dh-ints-spesialmodul', spesialmodul)
    if (
      this.features.lottie &&
      typeof customElements.get('dh-ints-basis-stegvis-lottie') === 'undefined'
    ) {
      const stegvisLottie = (
        await import('@nrk/dh-basis-stegvis-lottie' /* webpackChunkName: "dh-stegvis-lottie" */)
      ).default

      safeDefine('dh-ints-basis-stegvis-lottie', stegvisLottie)
    }

    if (this.features.kart && typeof customElements.get('dh-ints-kart') === 'undefined') {
      const kart = (
        await import('./lib/karthistorie-chunk' /* webpackChunkName: "dh-karthistorie" */)
      ).default

      safeDefine('dh-ints-kart', kart)
    }

    this.addEventListener('dh-basis-scrollhistorie-trigger-activated', (e) => {
      e.preventDefault()
      this.sendGaEvent({ eventAction: 'TRIGGER-ACTIVATED', eventLabel: e.detail.triggerIndex })
    })

    if (location.hostname.startsWith('preview') || location.hostname.startsWith('localhost')) {
      toArray(this.querySelectorAll(`.${styles.introscroll__error}`)).forEach((error) => {
        error.style.display = 'block'
      })
    }
  }

  get features() {
    return JSON.parse(this.getAttribute('features'))
  }
}

safeDefine(tag, AppElement)
